/**
 * Binds all function members of object to itself (in-place)
 */
const bindMethods = <T>(obj: T): T => {
	if (obj && typeof obj === "object") {
		for (const key of Object.keys(obj) as (keyof T)[]) {
			const fn = obj[key];

			if (typeof fn === "function") {
				obj[key] = fn.bind(obj);
			}
		}
	}

	return obj;
};

export default bindMethods;
